// Toggles the "sizes in stock" display on every product card at once,
document.addEventListener('click', (event) => {
	const toggle = event.target.closest('[data-toggle-sizes-in-stock]')
	if (!toggle) return

	event.preventDefault()
	const isExpanded = document.body.classList.toggle('show-sizes-in-stock')

	document.querySelectorAll('[data-toggle-sizes-in-stock]').forEach((button) => {
		button.setAttribute('aria-expanded', isExpanded)
	})
})
